import { Directive, ElementRef, Input, OnChanges, Renderer2, Self, SimpleChanges } from '@angular/core';


import { SecondMs } from 'rev-shared/date/Time.Constant';

import { InThisVideoEntryAngularComponent } from 'rev-portal/media/videos/videoPlayback/inThisVideo/InThisVideoEntryAngular.Component';

const TRANSITION_DURATION_MS: number = 750;
const TRANSITION_DURATION_SEC: number = TRANSITION_DURATION_MS / SecondMs;

@Directive({
	selector: '[pulse-carousel-entry-order]'
})
export class PulseCarouselEntryOrderDirective implements OnChanges {

	@Input() public currentSlideIndex: number;
	@Input() public currentTimeSec: number;

	private element: HTMLElement;

	constructor(
		elementRef: ElementRef,
		private renderer: Renderer2,
		private inThisVideoEntry: InThisVideoEntryAngularComponent
	){
		this.element = elementRef.nativeElement;
	}

	public ngOnChanges(changes: SimpleChanges): void {
		if (changes.currentSlideIndex || changes.currentTimeSec) {
			this.updateOrder();
		}
	}

	private get isOrderUpdatesEnabled(): boolean {
		return this.currentSlideIndex === 0;
	}

	private get leftPosition(): number {
		return this.element.offsetLeft;
	}

	private animateTranslationToNewPosition(): void {
		window.setTimeout(() => {
			this.renderer.setStyle(this.element, 'transition', `transform ${TRANSITION_DURATION_SEC}s`);
			this.renderer.setStyle(this.element, 'transform', 'translateX(0)');

			this.resetTransition(TRANSITION_DURATION_MS);
		});
	}

	private resetTransition(delayMs: number): void {
		window.setTimeout(() => {
			this.renderer.setStyle(this.element, 'transition', 'none');
		}, delayMs);
	}

	private translateToPriorPosition(beforeX: number, afterX: number): void {
		this.renderer.setStyle(this.element, 'transform', `translateX(${beforeX - afterX}px)`);
	}

	private updateOrder(): void {
		if (this.isOrderUpdatesEnabled) {
			const beforeX: number = this.leftPosition;
			const currentActiveValue: boolean = this.inThisVideoEntry.isActiveTimeRage;

			this.renderer.setStyle(this.element, 'order', currentActiveValue ? 0 : 1);

			const afterX: number = this.leftPosition;

			if (beforeX !== afterX) {
				this.translateToPriorPosition(beforeX, afterX);

				this.animateTranslationToNewPosition();
			}
		}
	}
}
